/*

The Eiis Store class

 */
import BaseObject from "./Base.js"
import Events from "./Events.js"
import * as constants from "./Constants.js"

export default class Store extends BaseObject {

	constructor(config) {
		super(config);

		if (!this.name) {
			this.log.warning(this, "Wait, what!? I do not have a name!?");
		}

		// data records is an array container for server side data
		this.data = {};
		this.data.records = [];
		this.data.readonly = true;

		// create artificial lag for simulating slow network
		this.networkDelay = 0;
	}

	get records() {
		return this.data.records;
	}

	set records(recs) {
		this.data.records = recs;
	}

	get record() {
		return this.data.records[0];
	}

	recordCount() {
		return this.data.records.length;
	}

	clear() {
		this.data = {};
		this.data.records = [];
	}

	insert(data) {
		if (!data)
			return;
		if (Array.isArray(data)) {
			for (const rec of data) {
				this.data.records.push(rec);
			}
		} else {
			this.data.records.push(data);
		}
	}

	buildQueryString() {
		let query = "";
		if (this.start)
			query += `&start=${this.start}`;
		if (this.limit)
			query += `&limit=${this.limit}`;
		if (this.filters)
			query += encodeURI(`&filters=${this.filters}`);
		if (this.sort)
			query += encodeURI(`&sort=${this.sort}`);
		// replace first character if it is a &
		if (query.charAt(0) === "&")
			query = query.replace("&", "?");
		return query;
	}

	load() {
		let me = this;
		let authToken = localStorage.getItem("Eiis-AuthToken") || "";

		if (this.cache) {
			if (localStorage.getItem(this.name)) {
				this.log.info(this, "using local cache to load", this.name);
				const records = JSON.parse(localStorage.getItem(this.name));
				this.insert(records);
				Events.fire(constants.STORE_LOADED, { store: this.name, data: this.records });
				return {
					loaded: true
				}
			}
		}

		let endpoint = this.endpoint;
		const query = this.buildQueryString();

		this.log.info(this, "loading", this.name, "with async fetch from", endpoint, query);
		fetch(endpoint + query, {
			method: "GET",
			//credentials: "include", // TODO enable Access-Control-Allow-Credentials on server side
			headers: new Headers({
				"Accept": "application/json",
				"Eiis-AuthToken": authToken
			})
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			if (json.code && json.code === 403) {
				//Eiis.Logger.error("fetch error: ", json.error);
				if (json.error.includes("token is expired")) {
					localStorage.removeItem("Eiis-AuthToken");
					localStorage.setItem("loginMessage", "::LoginExpiredMessage::");
					document.location = "/login";
				} else {
					throw new Error(json.message);
				}
			}
			if (json.code && json.code !== 200) {
				this.log.error("fetch error: ", json.error);
				throw new Error(json.message);
			}

			if (json.readonly)
				me.data.readonly = json.readonly;

			const data = json[me.dataItems]
			me.log.debug(me, "got records", data);
			me.records = [];
			me.insert(data);

			// optionally keep state in localStorage
			if (me.cache) {
				localStorage.setItem(me.name, JSON.stringify(me.records));
			}

			setTimeout(function() {
				Events.fire(constants.STORE_LOADED, { store: me.name, data: me.records });
			}, me.networkDelay);

		}).catch((error) => {
			// network or request error
			this.log.error(me, "woops: " + error);
			const userMessage = this.language ? this.language.get(error.message) : error.message;
			Events.fire(constants.STORE_ERROR, {
				store: me.name,
				endpoint: me.endpoint,
				message: userMessage
			});
			Events.fire(constants.NOTIFICATION_ADD, {
				type: "error",
				message: userMessage,
				component: this.name,
				url: document.location
			});
		});
	}

	async save(rec, wait, action) {
		let authToken = localStorage.getItem("Eiis-AuthToken") || "";
		this.log.info(this, "saving to", this.endpoint);
		try {
			const response = await fetch(this.endpoint + "/" + action, {
				method: "POST",
				//credentials: "include", // TODO enable Access-Control-Allow-Credentials on server side
				headers: new Headers({
					"Accept": "application/json",
					"Eiis-AuthToken": authToken,
					"Content-Type": "application/json; charset=utf-8"
				}),
				body: JSON.stringify(rec)
			});
			const json = await response.json();
			if (!response.ok) {
				throw new Error(json.message);
			}
			return {
				saved: true,
				message: json
			}
		} catch (error) {
			if (wait) {
				return {
					saved: false,
					message: error.message
				}
			} else {
				Events.fire(constants.STORE_ERROR, {
					store: this.name,
					endpoint: this.endpoint,
					message: error.message
				});
				Events.fire(constants.NOTIFICATION_ADD, {
					type: "error",
					message: error.message,
					component: this.name,
					url: document.location
				});
			}
		}
	}
}
